import { useQuery } from "@tanstack/react-query";
import { fetchRecordConsumables } from "@/lib/services/appointmentModalService";

/**
 * Hook to fetch consumables for a specific visit/record.
 * Fetches on demand when enabled is true.
 * @param recordId The record ID to fetch consumables for.
 * @param enabled Whether to enable the query (fetch on demand).
 */
export function useVisitConsumables(recordId: number | undefined, enabled: boolean) {
    return useQuery({
        queryKey: ["visitConsumables", recordId],
        queryFn: () => fetchRecordConsumables(recordId ?? 0),
        enabled: !!recordId && enabled,
        staleTime: 5 * 60 * 1000, // 5 minutes cache
    });
}
